<template>
  <div
    class="v-select-basic"
    @click.self="toggleDropdown"
    :class="{ 'v-select-basic--active': isOpen }"
    v-click-outside="closeDropdown"
  >
    <div
      class="v-select-basic__label"
      :class="{
        'v-select-basic__label--float': selectedOption || isOpen,
        'v-select-basic__label--float--active': isOpen
      }"
    >
      {{ selectorLabel }}
    </div>
    <div class="v-select-basic__selected-option">
      {{ selectedOption ? selectedOption.label : "" }}
    </div>
    <v-icon class="v-select-basic__icon" name="caret" width="12" />
    <div
      class="v-select-basic__dropdown"
      :class="{
        'v-select-basic__dropdown--mobile': isMobile && !mobileTakeover,
        'v-select-basic__dropdown--mobile-takeover': isMobile && mobileTakeover,
        'v-select-basic__dropdown--desktop': !isMobile
      }"
      v-show="isOpen"
      @click.self="toggleDropdown"
    >
      <button
        class="v-select-basic__dropdown__close"
        v-if="isMobile && mobileTakeover"
        @click="closeDropdown"
      >
        Luk
      </button>
      <ul
        class="v-select-basic__options"
        :class="{
          'v-select-basic__options--mobile': isMobile && !mobileTakeover,
          'v-select-basic__options--mobile-takeover':
            isMobile && mobileTakeover,
          'v-select-basic__options--desktop': !isMobile
        }"
      >
        <li
          v-for="option in options"
          class="v-select-basic__option"
          :class="{
            'v-select-basic__option--selected': option.value === value
          }"
          :key="option.value"
          @click="selectOption(option)"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "VSelectBasic",
  props: {
    label: String,
    options: Array,
    selectorLabel: String,
    value: [String, Object],
    mobileTakeover: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      selectedOption: null,
      mobileBreakpoint: 768,
      windowWidth: window.innerWidth
    };
  },
  created() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  computed: {
    isMobile() {
      return this.windowWidth < this.mobileBreakpoint;
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    selectOption(option) {
      this.selectedOption = option;
      this.$emit("input", option.value);
      this.closeDropdown();
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.closeDropdown();
      }
    }
  },
  directives: {
    clickOutside: {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-select-basic {
  position: relative;
  height: 50px;
  border-radius: 5px;
  border: 1px solid theme-color("border");
  background-color: theme-color("white");
  &--active {
    border-color: theme-color("focus");
  }
  &__label {
    inset-block-start: 50%;
    transform: translateY(-50%);
    line-height: 1.1;
    position: absolute;
    pointer-events: none;
    white-space: nowrap;
    padding-inline: 15px;
    color: theme-color("placeholder");
    transition: all 200ms ease-out;
    &--float {
      inset-block-start: 0;
      position: absolute;
      display: inline-block;
      font-size: 0.8125rem;
      padding-inline: 5px;
      inset-inline-start: 10px;
      background-color: theme-color("white");
      &--active {
        color: theme-color("focus");
      }
    }
  }
  &__icon {
    position: absolute;
    inset-block-start: 50%;
    inset-inline-end: 1em;
    transform: translateY(-50%);
  }
  &__selected-option {
    position: relative;
    inset-block-start: 50%;
    transform: translateY(-50%);
    line-height: 1.1;
    padding-inline: 15px;
    pointer-events: none;
  }

  &__dropdown {
    &--desktop {
      position: absolute;
      inset-block-start: 15px;
      inset-inline-start: -1px;
      width: calc(100% + 2px);
      border: 1px solid theme-color("focus");
      border-block-start: none;
      border-end-start-radius: 5px;
      border-end-end-radius: 5px;
    }
    &--mobile {
      @extend .v-select-basic__dropdown--desktop;
    }
    &--mobile-takeover {
      position: fixed;
      inset: 0 0 0 0;
      width: 100%;
      height: 100%;
      z-index: 100;
    }
    &__close {
      position: absolute;
      z-index: 1;
      inset-block-start: 0;
      inset-inline-end: 0;
      background-color: transparent;
      border: none;
      padding: 15px 12px 15px 20px;
      color: theme-color("danger");
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  &__options {
    background: white;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    border-radius: 5px;
    padding: 0;
    box-shadow: 1px 6px 10px 0 rgba(0, 0, 0, 0.3);
    list-style: none;
    margin: 0;
    position: relative;
    &--desktop {
      max-height: 300px;
    }
    &--mobile {
      max-height: 250px;
    }
  }
  &__option {
    padding: 10px 15px;
    cursor: pointer;
    &:hover {
      background-color: #f5f5f5;
    }
    &--selected {
      color: theme-color("focus");
    }
  }
}
</style>
